export default __webpack_public_path__ + "static/media/laguna2.3b953b01.jpg";